import Vue from 'vue'
import JsonViewer from 'vue-json-viewer/ssr'

Vue.use(JsonViewer)
